var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"list-header\">{{::vm.constructorArgs.listTitle}}</div><div layout=\"row\" class=\"listHeaderFilters\"><div flex=\"50\" layout=\"column\" layout-align=\"end start\"><is-loading></is-loading></div><div flex=\"50\" layout=\"row\" layout-align=\"end\"><form class=\"form-inline\"><div class=\"form-group\"><input ng-model=\"searchText\" placeholder=\"Filter Visible\" class=\"form-control\"/></div>&nbsp;<div class=\"form-group margin-left-med\"><select ng-model=\"vm.sortOrder\" ng-options=\"item.value as item.text for item in vm.sortOptions\" class=\"form-control\"></select></div></form></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/common/widgets/listHeader.jade
// module id = 528
// module chunks = 0